import React, { useMemo } from 'react';
import { Duration } from 'timezonecomplete';

import type { ITimelineHour, IWeekDay } from '@/types/calendar';

import { useTimezone } from '@/hooks';
import { getTimelineHours } from '@/constants/client';
import { TimelineHour } from '@/components/common';

interface IProps {
  day: IWeekDay;
}

const TimelineHours = ({ day }: IProps): React.ReactElement => {
  const { timezoneName } = useTimezone();

  const timelineHours = useMemo<ITimelineHour[]>(
    () => getTimelineHours(day, timezoneName, Duration.hours(1)),
    [day, timezoneName],
  );

  return (
    <div className="timeline-hours">
      {timelineHours.map((item, index) => (
        <TimelineHour key={index} hour={item} />
      ))}
    </div>
  );
};

export { TimelineHours };
